<template>
  <div :class='component.type'>
    <component-editing-header :component="component"
                              :disable-remove="isSelectedComponent || disableToolbarButtons"
                              :disable-moveto="isSelectedComponent || disableToolbarButtons"
                              :disable-add="true"
                              class='bg-white'
                              v-on='$listeners' />

    <property-form v-if='dataSchema'
                   :schema='dataSchema'
                   :model='component'
                   :transform='transform'
                   :partutil='partutil'
                   :transforms-and-source="transformsAndSource"
                   @validated='onValidated'
                   v-on='$listeners' />
      <div v-if='notMuchTodo'>
        <slot name="recommend" />
      </div>
  </div>
</template>
<script>
import ComponentEditingHeader from '@ui/molecules/ComponentEditingHeader.vue';
import EditingComponentMixin from '@components/editingComponentMixin.js';
export default {
  mixins: [EditingComponentMixin],
  components:{
    ComponentEditingHeader,
  },
  methods:{
    onValidated(nv) {
      this.$emit('validated', nv);
    }
  },
  mounted() {
    console.log('data schema', this.dataSchema);
    if (typeof(this.dataSchema) === 'undefined') {
      this.$emit('validated', true);
      this.$emit('autofinish');
    }
  },
  computed:{
    notMuchTodo() {
      const typeList = ['delay', 'tapcontroller', 'repeater', 'steps', 'collisionWith', 'onEvent'];
      return typeList.includes(this.component.type) || !this.dataSchema || ( !(this.dataSchema.length) && !(this.dataSchema.fields||[]).length && !(this.dataSchema.groups||[]).length);
    }
  }
}
</script>
